@for (item of steps; track $index) {
<div [class.active]="currentStep >= $index" class="step">
  <div class="title">{{item.title}}</div>
  <div class="progress"></div>
  <div class="sphere"></div>
</div>
}
